import React, { useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import { Alert, Divider, TextField, Typography } from '@mui/material';
import AlertD from '../util/AlertD';
import { getId, numberWithCommas } from '../util/ID'
import InputAdornment from '@mui/material/InputAdornment';

export default function SellDialog(props) {
    const [showAlert, setShowAlert] = React.useState(false);
    const [alertMsg, setAlertMsg] = React.useState(null);

    const [open, setOpen] = React.useState(false);
    const [bPrice, setBPrice] = React.useState("");
    const [num, setNum] = React.useState("");
    const [bYMD, setBYMD] = React.useState("");

    const handleClose = () => {
        setOpen(false);
        if (props.close != null) props.close(false)
        // if(props.refresh != null) props.refresh()
    };

    const handleOKClose = () => {
        clickLove()
    };

    const getAvg = () => {
        return localStorage.getItem("mv_avg") != null ? localStorage.getItem("mv_avg") : 100
    }

    const getATR = () => {
        return localStorage.getItem("mv_atr") != null ? localStorage.getItem("mv_atr") : 20
    }

    const getCapital = () => {
        return localStorage.getItem("mv_capital") != null ? localStorage.getItem("mv_capital") : 300000
    }

    const getMC = () => {
        return localStorage.getItem("mv_mc") != null ? localStorage.getItem("mv_mc") : 200
    }

    const getCp = () => {
        return localStorage.getItem("mv_cp") != null ? localStorage.getItem("mv_cp") : 0
    }

    const getMD = () => {
        return localStorage.getItem("mv_md") != null ? localStorage.getItem("mv_md") : 90
    }

    const clickLove = () => {
        if (props.row != null && bPrice != "" && bYMD != "" && num != "") {
            setOpen(false);
            if (props.close != null) props.close(false)

            let risk = localStorage.getItem("mv_risk") != null ? localStorage.getItem("mv_risk") : 0.1
            let gap = localStorage.getItem("mv_gap") != null ? localStorage.getItem("mv_gap") : 15

            
            let param = {
                sn: getId(),
                id: props.row.id,
                sprice: bPrice,
                symd: bYMD,
                num: num,
                capital: getCapital(),
                risk: parseFloat(risk) / 100,
                gap: gap,
                avg: getAvg(),
                atr_days: getATR(),
                mc: getMC(),
                cp : getCp(),
                md: getMD()          
            }

            if (localStorage.getItem("move_lic") != null) {
                param['lic'] = localStorage.getItem("move_lic")
            }

            fetch("/move/v1/app/sell", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(param)
            })
                .then(res => res.json())
                .then(
                    result => {
                        if (result != null && result.status === 0) {
                            if (props.refresh != null) props.refresh()
                            // if (props.updateLove != null) props.updateLove(props.row.stock)
                        } else if (result != null && result.status === -3) {
                            setAlertMsg("沒有任何庫存，無法賣出。")
                            setShowAlert(true)
                        }else if (result != null && result.status === -5) {
                            setAlertMsg("庫存數量有誤，無法賣出。")
                            setShowAlert(true)
                        }else if (result != null && result.status === -4) {
                            setAlertMsg("庫存數量不足，無法賣出。")
                            setShowAlert(true)
                        }
                    }
                );
        } else {
            setAlertMsg("請輸入股票購買價格，數量與日期。")
            setShowAlert(true)
        }
    }

    const clickDel = () => {
        if (props.row != null) {
            setOpen(false);
            if (props.close != null) props.close(false)
         
            let param = {
                sn: getId(),
                id: props.row.id,
            }

            if (localStorage.getItem("move_lic") != null) {
                param['lic'] = localStorage.getItem("move_lic")
            }

            fetch("/move/v1/btran/del", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(param)
            })
                .then(res => res.json())
                .then(
                    result => {
                        if (result != null && result.status === 0) {
                            if (props.refresh != null) props.refresh()
                        } 
                    }
                );
        } else {
            // setAlertMsg("請輸入股票購買價格，數量與日期。")
            // setShowAlert(true)
        }
    }

    useEffect(() => {
        if (props.open) setOpen(true)
        else setOpen(false)
    }, [props.open]);

    const roi = (bprice, nprice) => {
        return (((nprice / bprice) - 1) * 100).toFixed(2)
    }

    return (
        <div>
            {showAlert ? <AlertD desc={alertMsg} open={showAlert} close={setShowAlert}></AlertD> : null}
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={open}
                onClose={handleClose}
            >
                <DialogTitle id="alert-dialog-title">
                    賣出 / 刪除
                </DialogTitle>
                {/* <Divider></Divider> */}

                <DialogContent sx={{ p: 3 }}>
                    {/* <Typography fontWeight={"bold"} variant='subtitle1'>參考</Typography> */}

                    <Stack spacing={0.2} direction="column" sx={{ mt: 0 }}>
                        <Stack direction={"row"}>
                            <Typography fontWeight={"bold"} variant="subtitle1" >股票名稱：</Typography>
                            <Typography sx={{ color: "gray" }} variant="subtitle1">
                                {props.row.company.short_name} {props.row.company.stock_no}</Typography>
                        </Stack>
                        <Stack direction={"row"}>
                            <Typography fontWeight={"bold"} variant="subtitle1" >買進日期：</Typography>
                            <Typography sx={{ color: "gray" }} variant="subtitle1">
                                {props.row.bymd}
                            </Typography>
                        </Stack>
                        <Stack direction={"row"}>
                            <Typography fontWeight={"bold"} variant="subtitle1" >持有價格：</Typography>
                            <Typography sx={{ color: "gray" }} variant="subtitle1">
                                {props.row.bprice}元</Typography>
                        </Stack>
                        <Stack direction={"row"}>
                            <Typography fontWeight={"bold"} variant="subtitle1" >持有股數：</Typography>
                            <Typography sx={{ color: "gray" }} variant="subtitle1">
                                {numberWithCommas(props.row.num)}股</Typography>
                        </Stack>
                    </Stack>

                    <Stack spacing={1} direction="column" sx={{ mt: 2 }}>
                        <TextField
                            value={bPrice}
                            onChange={event => setBPrice(event.target.value)}
                            inputProps={{  }}
                            size="medium" label="賣出價位" fullWidth InputProps={{
                                endAdornment: <InputAdornment position="end">元</InputAdornment>,
                            }}></TextField>
                        <TextField
                            value={num}
                            onChange={event => setNum(event.target.value)}
                            size="medium" label="賣出股數" fullWidth
                            inputProps={{  }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">股</InputAdornment>,
                            }}></TextField>
                        <TextField size="medium" label="賣出日期" fullWidth
                            value={bYMD}
                            onChange={event => setBYMD(event.target.value)}
                            helperText="YYYYMMDD，例如：20220930"
                            inputProps={{  }}
                        ></TextField>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button sx={{width:80}} disableElevation   onClick={clickDel} autoFocus>
                        直接刪除
                    </Button>
                    <Button sx={{width:80}} onClick={handleClose}>取消</Button>
                    <Button sx={{width:80}} onClick={handleOKClose} autoFocus>
                        賣出
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
